import {
  AutocompleteError, BacktoAllJobs, Button, ButtonStyle, Checkbox, components, cursorNone, draftJob, Field, Form, Formik, FormikControl,getClientUsers, getDepartmentsList, goToNextPage, getJobTitles, getSession, getJobWithTitleId, hideDraft, handleFormSubmit, Image, InputError, InputText, jobStatusBadge, JOB_STEPS, PageStyle, REDIRECT, React,
  style, useEffect, useQueryClient, useRef, useRouter, useState, useTranslation,
  VALIDATION_SCHEMA, job_validation, previewJob, NumberField, DataFromUrl, getRequiredApprovedHash, handleRequiredApproved, getValueHash, SelectJobModal, ClientDashboard, ArrowLeft, Loading, showImportPreviousJob, arrayEquals, CustomToastrAction,
canGenerateDescription, DescriptionModal, languageList, toneOfVoiceList, isFloat, DefaultCheckbox, HoverCheckbox, CheckedCheckbox, DisabledCheckbox, SelectedDisabledCheckbox, Exclamation,
TRANSLATION} from '@/imports-files/pages/clients/jobs/new';
import "react-datetime/css/react-datetime.css";
import PlaceAutoComplete from 'react-places-autocomplete';
import Tooltip from "react-simple-tooltip";
import Modal from "@/components/common-modal/modal";
import Import from "public/icons/import.svg";

function JobForm(props) {
  const queryClient = useQueryClient();
  const result = props.result
  const initialValues = props.initialValues
  const action = props.action
  const [text, setText] = useState("");
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const [minSalaryLabel, setMinSalaryLabel] = useState(t("jobs:details:input:min_salary"))
  const [maxSalaryLabel, setMaxSalaryLabel] = useState(t("jobs:details:input:max_salary"))
  const [minSalaryHolder, setMinSalaryholder] = useState(t("jobs:details:input:min_salary"))
  const [maxSalaryHolder, setMaxSalaryholder] = useState(t("jobs:details:input:max_salary"))
  const [users, setUsers] = useState([]);
  const [cancelPopup, setCancelPopup] = useState(false);
  const [buttonPopup, setButtonPopup] = useState(false);
  const editorRef = useRef(null);
  const formRef = useRef(null);
  const current_step = JOB_STEPS.DETAILS
  const Placeholder = (props) => { return <components.Placeholder {...props} />; };
  const [submitState, setSubmitState] = useState('');
  const [jobPreview, setJobPreivew] = useState({});
  const fromKanban = router.query.from_kanban ? true : false;
  const [gotoKanban, setGotoKanban] = useState(false);
  var jobId = new DataFromUrl().getJobId();
  const editable = initialValues.job.editable
  const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  const [flagForRender, setFlagForRender] = useState();
  const [showLoader, setShowLoader] = useState(false)
  const [descriptionModal, setDescriptionModal] = useState({state: false, data: {language: 'English UK', tone_of_voice: ''}})
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [jobTitleData, setJobTitleData] = useState([]);
  const [privacyPolicyModal, setPrivacyPolicyModal] = useState({state: false, current_user_type: ""});

  useEffect(async () => {
    let session = await getSession()
    if (result.privacy_policy_created){
      if (action == 'new') {
        if (!initialValues.job.job_owner_emails.includes(result.job_owner.user_attributes.email) && (session?.role != 'Administrator')) {
          initialValues.job.job_owner_emails.push(result.job_owner.user_attributes.email)
          initialValues.job.job_owner_initials.push({ email: result.job_owner.user_attributes.email, photo_url: result.job_owner.user_attributes.photo_url, name_initials: result.job_owner.user_attributes.name_initials, name: result.job_owner.user_attributes.name })
        }
        initialValues.job.approvers = {emails: new Array(), initials: new Array(), required_approvers: ''}
        // setInitialJobOwners([...initialValues.job.job_owner_emails])
      }
    }else{
      setPrivacyPolicyModal({state:true, current_user_type: session.role})
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, []);

  const jobtitle = []
  const jobindustries = result?.industries ? props.initialValues.job.is_old ? result?.industries.filter(item => ['previous', 'combined'].includes(item.type)) : result.industries.filter(item => ['current', 'combined'].includes(item.type)) : []
  const salarychoice = result?.salary_choices ? result.salary_choices : []
  var salaryduration = result?.salary_duration ? result.salary_duration : []
  const currency = result?.currencies ? result.currencies : []
  const seniority = result?.seniority_levels ? result.seniority_levels : []
  const education = result?.education ? result.education : []
  const location = result?.location ? result?.location : ''
  if (action == "new") {
    initialValues.job.location_attributes.full_address = location
    initialValues.job.location_attributes.place_id = ""
    initialValues.job.job_salary_detail_attributes.currency_id = currency[0]?.value
  }
  else if (action == "edit") {
    initialValues.job.job_title_name = initialValues.job?.job_title || ''
    if (!initialValues.job.location_attributes) {
      initialValues.job.location_attributes = {
        full_address: '',
        place_id: ''
      }
    }

    if (initialValues.job.contract_type == 'contract') {
      let per_day = salaryduration.filter(x => x.value == 'per_day')[0]
      let others = salaryduration.filter(x => x.value != 'per_day')
      let values = [per_day]
      others.map((x) => values.push(x))
      salaryduration = values
    }
  }
  const [currencySymbol, setCurrencySymbol] = useState(currency.filter((x) => x.value == initialValues.job.job_salary_detail_attributes.currency_id)[0]?.symbol || currency[0]?.symbol);
  initialValues.job.step = current_step
  const [value, setJobTitle] = useState(initialValues.job.job_title_name || initialValues.job.job_title || '')
  const [jobTitleOptions, setJobTitleOptions] = useState({option: [], data_fetch: false})
  const [jobDepartmentOptions, setJobDepartmentOptions] = useState({option: [], data_fetch: false})
  const [job_status, setJobStatus] = useState(initialValues.job.status || "open");
  function salaryInputs(salary_choice) {
    switch (salary_choice) {
      case "range":
        return ["min_salary", "max_salary"]
      case "starting":
        return ["min_salary"]
      default:
        return ["max_salary"]
    }
  }
  const [salaryInput, setSalaryInput] = useState(salaryInputs(initialValues.job.job_salary_detail_attributes.salary_choice))

  function handleIsRemote(event, formik) {
    let isChecked = event.target.checked
    let inputName = event.target.getAttribute('name')
    if (isChecked){
      formik.setFieldValue(inputName, isChecked);
      formik.setFieldValue("job.is_hybrid", false);
    }
    else{
      formik.setFieldValue(inputName, isChecked);
    }
  }

  function handleIsHybrid(event, formik){
    let isChecked = event.target.checked
    let inputName = event.target.getAttribute('name')
    if (isChecked){
      formik.setFieldValue(inputName, true);
      formik.setFieldValue("job.is_remote", false);
    }
    else{
      formik.setFieldValue(inputName, isChecked);
    }
  }

  function handleSalaryHidden(event, formik) {
    let isChecked = event.target.checked
    let inputName = event.target.getAttribute('name')
    formik.setFieldValue(inputName, isChecked);
    formik.setFieldValue('job.job_salary_detail_attributes.salary_displayed', '');
  }

  function handleWithoutCV(event, formik) {
    let isChecked = event.target.checked
    let inputName = event.target.getAttribute('name')
    formik.setFieldValue(inputName, isChecked);
  }

  function handleSalaryChoice(option, formik, event) {
    let array = []
    formik.setFieldValue(event.name, option.value)
    switch (option.value) {
      case "range":
        array = ["min_salary", "max_salary"]
        setMinSalaryLabel("Min Salary")
        setMaxSalaryLabel("Max Salary")
        setMinSalaryholder("Min Salary")
        setMaxSalaryholder("Max Salary")
        setSalaryInput([...array])
        formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
        formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
        break;
      case "starting":
        array = ["min_salary"]
        setMinSalaryLabel("Salary")
        setMinSalaryholder("Salary")
        setSalaryInput([...array])
        formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
        formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
        break;
      default:
        array = ["max_salary"]
        setMaxSalaryLabel("Salary")
        setMaxSalaryholder("Salary")
        setSalaryInput([...array])
        formik.setFieldValue("job.job_salary_detail_attributes.min_salary", "");
        formik.setFieldValue("job.job_salary_detail_attributes.max_salary", "");
    }
  }

  function getSuggestionValue(suggestion) {
    return suggestion.label;
  }
  function renderSuggestion(suggestion) {
    return (
      <span>{suggestion.label}</span>
    );
  }

  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());
    if (escapedValue === '') {
      return [];
    }
    let jobTitles = await getJobTitles(escapedValue, router)
    return jobTitles
  }

  async function onSuggestionsFetchRequested({value}) {
      if(!jobTitleOptions.data_fetch){
          let jobtitles = await getSuggestions(value);
          setJobTitleData(jobtitles);
          setJobTitleOptions({option: [], data_fetch: true});
      }

    let filteredData = jobTitleData.filter(
      title => title?.label.toLowerCase().includes(value.toLowerCase())
    );
    setJobTitleOptions({option: filteredData, data_fetch: true});
  };

  const onSuggestionsClearRequested = () => {
    setJobTitleOptions({option: [], data_fetch: jobTitleOptions.data_fetch})
  };

  const renderInputComponent = inputProps => (
    <input className={PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
  );

  function shouldRenderSuggestions(value) {
    return value?.trim().length >= 1
  }

  async function getDepartmentSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value?.trim());

    if (escapedValue === '') {
      return [];
    }
    let departments = await getDepartmentsList(escapedValue, router)
    return departments
  }

  async function onDepartmentSuggestionsFetchRequested({ value }) {
    if (!jobDepartmentOptions.data_fetch){
      let options = await getDepartmentSuggestions(value)
      setDepartmentList(options);
      setJobDepartmentOptions({option: [], data_fetch: true})
    }

    let filteredData = departmentList.filter(
      department => department?.toLowerCase().includes(value.toLowerCase())
    );
    setJobDepartmentOptions({option: filteredData, data_fetch: true})
  };

  const onDepartmentSuggestionsClearRequested = () => {
    setJobDepartmentOptions({option: [], data_fetch: jobDepartmentOptions.data_fetch})
  };

  function getDepartmentSuggestionValue(suggestion) {
    return `${suggestion}`;
  }

  function renderDepartmentSuggestion(suggestion) {
    return (
      <span>{suggestion}</span>
    );
  }

  const renderDepartmentInputComponent = inputProps => (
    <input className={PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
  );

  function languageList(t) {
    return [
      { label: t("jobs:languages:en-US"), value: "English US" },
      { label: t("jobs:languages:en-UK"), value: "English UK" },
      { label: t("jobs:languages:sv-SE"), value: "Swedish" },
      { label: t("jobs:languages:nb-NO"), value: "Norwegian" },
      { label: t("jobs:languages:da-DK"), value: "Danish" },
      { label: t("jobs:languages:es-ES"), value: "Spanish" },
      { label: t("jobs:languages:de-DE"), value: "German" },
      { label: t("jobs:languages:fr-FR"), value: "French" },
    ];
  }

  function onContractTypeChange(event, formik) {
    formik.setFieldValue('job.contract_type', event.target.value)
    if (event.target.value == 'contract') {
      let per_day = salaryduration.filter(x => x.value == 'per_day')[0]
      let others = salaryduration.filter(x => x.value != 'per_day')
      let values = [per_day]
      others.map((x) => values.push(x))
      salaryduration = values
    }
    else {
      let per_day = salaryduration.filter(x => x.value == 'per_day')[0]
      let others = salaryduration.filter(x => x.value != 'per_day')
      others.push(per_day)
      salaryduration = others
    }
  }

  function shouldFetchSuggestions(formik) {
    return formik.values.job.location_attributes?.full_address?.length >= 3
  }

  function showErrorAlert(formik){
    if (formik.errors.job != undefined){
    new CustomToastrAction().setNormalToastr(TRANSLATION('errors:complete_fields'), 'warning');
    }
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

   const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  return (

    <>

      <div className={`Page NewJob ${PageStyle.NewJob} job-form-section`}>
        <BacktoAllJobs trigger={cancelPopup} 
                       setCancelPopup={setCancelPopup} 
                       setPageName={props.setPageName} 
                       queryClient={queryClient} 
                       formRef= {formRef}
                       setSubmitState = {setSubmitState}
                       save_as_draft = {true}

                       />
        <div className={`${PageStyle.NewJob__Wrapper} ${PageStyle.NewJob__ContainerScroll} ${PageStyle.NewJob__ContainerHeight}`}>
          <Formik
            initialValues={initialValues}
            validationSchema={job_validation(submitState, job_status)}
            initialErrors={{}}
            innerRef={formRef}
            onSubmit={async (values, actions) => {
              
              values.job.job_salary_detail_attributes.min_salary = values.job.job_salary_detail_attributes?.min_salary?.toString()?.replaceAll(',', '')
              values.job.job_salary_detail_attributes.max_salary = values.job.job_salary_detail_attributes?.max_salary?.toString()?.replaceAll(',', '')


              if (submitState == 'draft' || (submitState == 'preview' && job_status != 'active')) {
                await draftJob(values, router, current_step, props.setPageName, queryClient, setJobStatus, setDisabledSaveButton, formRef, submitState)
                formRef.current.resetForm({ values });
              }
              else if (submitState == 'preview') {
                previewJob(router, values.id)
              }
              else {
                const errors = await handleFormSubmit(values, router, t, props.setPageName, queryClient, formRef, fromKanban, gotoKanban, setDisabledSaveButton);
                actions.setErrors(errors)
              }
            }}
            
          >
            {(formik) => (
              <Form className={PageStyle.Form}>
                <div className={`${PageStyle.NewJob__TopSection}`}>
                  <div className={PageStyle.ClientCompany__BackSection}>

                    <span onClick={() => {
                      if (fromKanban) {
                        router.push({ pathname: REDIRECT.client.kanban_board.replace('$job_id', jobId) });
                      }
                      else if (job_status.toLocaleLowerCase() == "open"){
                        setCancelPopup(true)
                      }
                      else if (job_status.toLocaleLowerCase() == "draft"){
                        if(formik.dirty)
                          setCancelPopup(true)
                        else
                          router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'active' }})
                      }
                      else
                        router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'active' } });
                      // goToNextPage('jobs', props.setPageName, queryClient, REDIRECT.client.jobs.index)
                    }}
                    >
                      <ArrowLeft />
                      <span>{fromKanban ? t('back:kanban') : t('back:all_jobs')}</span>

                    </span>
                  </div>
                </div>
                  <div className={PageStyle.NewJob__ImportAction}>
                    <h1 className={` ${PageStyle.ClientCompany__Heading} ${PageStyle.ClientCompany__StatusAlignment} m0`}>
                    {t("jobs:details:title_1")}:{" "}
                        <span className={`${PageStyle.LightBlueColor}`}> {t("jobs:details:title_2")} </span>
                        {((job_status == "active") || (job_status == "archived")) && <div className={`${PageStyle.ClientCompany__Status} ml12`}>
                        <h5 className={PageStyle.ClientCompany__StatusTag}><span className={jobStatusBadge(job_status)}></span>{job_status ==  "archived" ? t('tabs:archived') : t('tabs:active') }</h5>
                      </div>
                    }
                      </h1>
                      {showImportPreviousJob(router, initialValues) && <Button buttonstyle={`${PageStyle.secondarybtn} buttonWithIcon`}  onClick={() => setButtonPopup(true)}><Import />{t("button:import:previous_job")}</Button>}
                  </div>
                  <div className = {`mb32`}>
                    {job_status == "active" && <span className={`${PageStyle.ClientCompany__Systemrefheding} mr15`}>{t("jobs:system_ref")} : {initialValues.job?.system_reference}</span>}
                  </div>
                  <h4 className={PageStyle.ClientCompany__Subheading}>
                  {t("jobs:details:subheading")}{" "}
                  </h4>
                  <div className={PageStyle.Form}>
                    <div className={PageStyle.Form__Table}>

                      <div className={PageStyle.Form__TableRow}>
                        <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, `job.job_title_name`)}><span className={`red-color`}>*</span> {t('jobs:details:input:job_title')}</span>
                          <FormikControl
                            control="autosuggestInput"
                            type="text"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            inputProps={{
                              className: `${PageStyle.Form__Input}`,
                              formik: formik,
                              name: "job.job_title_name",
                              onChange: (value, { newValue, method }) => {
                                setJobTitle(newValue)
                                formik.setFieldValue('job.job_title_name', newValue)
                              },
                              placeholder: "e.g Product Designer",
                              style: InputError(formik, `job.job_title_name`),
                              value: value,
                              disabled: !editable
                            }}
                            suggestions={jobTitleOptions.option}
                            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onSuggestionsClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            renderInputComponent={renderInputComponent}
                            shouldRenderSuggestions={shouldRenderSuggestions}
                            onSuggestionSelected={(event, { suggestion }) => {
                            }}
                          />
                        </div>

                        <div className={PageStyle.Form__TableCol}>
                          <FormikControl
                            control="input"
                            type="text"
                            formik={formik}
                            /* placeholder     =   "Insert reference" */
                            name="job.internal_reference"
                            className={PageStyle.Form__Input}
                            errorClass={PageStyle.Form__Error}
                            style={InputError(formik, "job.internal_reference")}
                            disabled={!editable}
                          />
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}>
                          {t('jobs:details:input:reference')}
                                </span>
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.mt10}`}>
                        <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}><span className={`red-color`}>*</span> {t('jobs:details:input:industry')}</span>

                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.width100}`}
                            components={{ Placeholder }}
                            control="select"
                            default={formik.values.job.industry_id}
                            formik={formik}
                            name="job.industry_id"
                            onChange={(option) => formik.setFieldValue("job.industry_id", option.value)}
                            options={jobindustries}
                            placeholder={t("placeholder:eg:financial")}
                            style={InputError(formik, "job.industry_id")}
                            value={jobindustries.filter(option => option.value === formik.values.job.industry_id)}
                            disabled={!editable}
                          />
                        </div>

                        <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}> {t('jobs:details:input:department')}</span>
                          <FormikControl
                            control="autosuggestInput"
                            type="text"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            inputProps={{
                              className: `${PageStyle.Form__Input}`,
                              formik: formik,
                              name: "job.department",
                              onChange: (value, { newValue, method }) => {
                                // setJobTitle(newValue)
                                formik.setFieldValue('job.department', newValue)
                              },
                             placeholder: t("placeholder:eg:design"),
                              style: InputError(formik, `job.department`),
                              value: formik.values.job.department || '',
                              disabled: !editable
                            }}
                            suggestions={jobDepartmentOptions.option}
                            onSuggestionsFetchRequested={onDepartmentSuggestionsFetchRequested}
                            onSuggestionsClearRequested={onDepartmentSuggestionsClearRequested}
                            getSuggestionValue={getDepartmentSuggestionValue}
                            renderSuggestion={renderDepartmentSuggestion}
                            renderInputComponent={renderDepartmentInputComponent}
                            shouldRenderSuggestions={shouldRenderSuggestions}
                            onSuggestionSelected={(event, { suggestion }) => {
                              console.log(suggestion)
                            }}
                          />
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.mt10} removeplaceholder`}>
                        <div className={PageStyle.Form__TableCol}>
                            <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}><span className={`red-color`}>*</span> {t('jobs:details:input:location')} 
                              <Tooltip className='SimpleTooltip' content = {t('tooltip:add_complete_address')} background= {'#00325A'} radius={20} padding = {8} placement  = "right">
                                <p className={`tooltipwidthinterview250 d-flex align-items-center`}>&nbsp;&nbsp;<Exclamation/></p>
                              </Tooltip>
                            </label>
                            
                          {<PlaceAutoComplete
                            value={formik.values.job.location_attributes.full_address}
                            onChange={async (value) => { if(formik.status?.job?.location_attributes?.full_address)
                                                        {
                                                         delete formik.status.job.location_attributes.full_address;
                                                         delete formik.status.job.location_attributes;
                                                         await formik.setStatus(formik.status);
                                                        }
                                                        await formik.setFieldValue('job.location_attributes.full_address', value)
                                                        await formik.setFieldValue('job.location_attributes.place_id', "")
                                                       }}
                            onSelect={(address, placeId, suggestion) => {
                              formik.setFieldValue('job.location_attributes.full_address', address)
                              formik.setFieldValue('job.location_attributes.place_id', placeId)
                            }}
                            shouldFetchSuggestions={shouldFetchSuggestions(formik)}
                          >

                            {({ getInputProps, getSuggestionItemProps, suggestions, loading }) => (
                              <div className="autocomplete-root">
                                <Field
                                  className={PageStyle.Form__Input}
                                  disabled={formik.values.job.is_remote}
                                  name="job.location_attributes.full_address"
                                  placeholder={t("placeholder:eg:postcode")}
                                  style={InputError(formik, "job.location_attributes.full_address")}
                                  {...getInputProps({ disabled: !editable })}
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading && <div> {t('loading')} </div>}
                                  {suggestions.map(suggestion => (
                                  <div key={suggestion.placeId} {...getSuggestionItemProps(suggestion)}>
                                      <span key={suggestion.id}>{suggestion.description}</span>
                                    </div>
                                  ))}
                                </div>

                              </div>
                            )}
                          </PlaceAutoComplete>}
                          <AutocompleteError
                            name="job.location_attributes.full_address"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "job.location_attributes.full_address")}
                            custom_error_90={'custom_error_90'}
                          />
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} Dpflex justify-start`}>
                        <span className={`${PageStyle.Form__CheckLabel} ${PageStyle.Form__LabelCheck} Mui__CustomCheckbox CheckLabelAlign mt0 wauto`}>
                          <div className={`Dpflex16`}>
                            <Checkbox
                              inputProps={{ "aria-label": "Checkbox A" }}
                              name="job.is_remote"
                              onChange={(event) => handleIsRemote(event, formik)}
                              style={InputError(formik, "job.is_remote")}
                              checked={formik.values.job.is_remote}
                              disabled={!editable}
                              icon={!editable ? (formik.values.job.is_remote ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<DefaultCheckbox />)}
                              checkedIcon={!editable ? (formik.values.job.is_remote ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<CheckedCheckbox />)}
                              />
                              {" "}
                              {t('jobs:details:input:remote')}
                          </div>
                          </span>
                          <span className={`${PageStyle.Form__CheckLabel} ${PageStyle.Form__LabelCheck} Mui__CustomCheckbox CheckLabelAlign mt0`}>
                            <div className='Dpflex16'>
                              <Checkbox
                                inputProps={{ "aria-label": "Checkbox A" }}
                                name="job.is_hybrid"
                                onChange={(event) => handleIsHybrid(event, formik)}
                                style={InputError(formik, "job.is_hybrid")}
                                checked={formik.values.job.is_hybrid}
                                disabled={!editable}
                                icon={!editable ? (formik.values.job.is_hybrid ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<DefaultCheckbox />)}
                                checkedIcon={!editable ? (formik.values.job.is_hybrid ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<CheckedCheckbox />)}
                                />
                                {" "}
                                {t('jobs:details:input:hybrid')}
                            </div>
                        </span>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.noDpGrid} ${PageStyle.mb12}`} >
                        <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label}`}>
                            <span className={`red-color`}>*{" "}</span>
                            {t('jobs:details:employment_type:heading')}
                          </span>

                          <div className={`wrapper`}>
                            <Field type="radio" name="job.employment_type" id="option-1" value="full_time" disabled={!editable} />
                            <Field type="radio" name="job.employment_type" id="option-2" value="part_time" disabled={!editable} />
                            <Field type="radio" name="job.employment_type" id="option-3" value="either" disabled={!editable} />

                            <label htmlFor="option-1" className={`option option-1 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:employment_type:full_time')}</span>
                            </label>
                            <label htmlFor="option-2" className={`option option-2 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:employment_type:part_time')}</span>
                            </label>

                            <label htmlFor="option-3" className={`option option-3 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:employment_type:either')}</span>
                            </label>
                          </div>

                          <AutocompleteError
                            name="job.employment_type"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "job.employment_type")}
                          />
                        </div>
                      </div>



                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.noDpGrid}`}>
                        <div className={PageStyle.Form__TableCol}>
                          <span className={PageStyle.Form__Label}>
                            <span className={`red-color`}>*{" "}</span>
                            {t('jobs:details:contract_type:heading')}
                          </span>
                          <div className={`wrapper2`}>
                            <Field type="radio" name="job.contract_type" id="option-4" value="permanent" onChange={(event) => onContractTypeChange(event, formik)} disabled={!editable} />
                            <Field type="radio" name="job.contract_type" id="option-5" value="contract" onChange={(event) => onContractTypeChange(event, formik)} disabled={!editable} />
                            <Field type="radio" name="job.contract_type" id="option-6" value="temporary" onChange={(event) => onContractTypeChange(event, formik)} disabled={!editable} />
                            <Field type="radio" name="job.contract_type" id="option-7" value="internship" onChange={(event) => onContractTypeChange(event, formik)} disabled={!editable} />

                            <label htmlFor="option-4" className={`option option-4 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:contract_type:permanent')}</span>
                            </label>
                            <label htmlFor="option-5" className={`option option-5 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:contract_type:contract')}</span>
                            </label>

                            <label htmlFor="option-6" className={`option option-6 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:contract_type:temporary')}</span>
                            </label>

                            <label htmlFor="option-7" className={`option option-7 ${cursorNone(editable)}`}>
                              <span>{t('jobs:details:contract_type:internship')}</span>
                            </label>
                          </div>

                          <AutocompleteError
                            name="job.contract_type"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "job.contract_type")}
                          />

                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow}`} >
                        <div className={PageStyle.Form__TableCol}>
                          <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.job_salary_detail_attributes.salary_choice')}>
                            <span className={`red-color`}>*</span>&nbsp;
                            {t('jobs:details:input:salary_choice')}
                          </label>

                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            components={{ Placeholder }}
                            control="select"
                            default={formik.values.job.job_salary_detail_attributes.salary_choice}
                            formik={formik}
                            name="job.job_salary_detail_attributes.salary_choice"
                            onChange={(option, event) => { handleSalaryChoice(option, formik, event) }}
                            options={salarychoice}
                            style={InputError(formik, 'job.job_salary_detail_attributes.salary_choice')}
                            value={salarychoice.filter(option => option.value === formik.values.job.job_salary_detail_attributes.salary_choice)}
                            disabled={!editable}
                          />
                        </div>

                        <div className={`CurrencyDropdown ${PageStyle.Form__TableCol}`}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.job_salary_detail_attributes.currency_id')}>
                            <span className={`red-color`}>*{" "}</span>{t('jobs:details:input:currency')}
                          </span>

                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            control="select"
                            default={formik.values.job.job_salary_detail_attributes.currency_id || currency[0].value}
                            formik={formik}
                            name="job.job_salary_detail_attributes.currency_id"
                            isCurrency={true}
                            currencySymbol={currencySymbol}
                            currencyClass={PageStyle.Form__currency_symbol}
                            onChange={(option) => {
                              setCurrencySymbol(option.symbol)
                              formik.setFieldValue("job.job_salary_detail_attributes.currency_id", option.value)
                            }}
                            options={currency}
                            style={InputError(formik, 'job.job_salary_detail_attributes.currency_id')}
                            disabled={!editable}
                          />
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow3grid} ${PageStyle.mt10} mb10`} >
                        {salaryInput.includes("min_salary") && <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.job_salary_detail_attributes.min_salary')}>
                            <span className={`red-color`}>*{" "}</span>{minSalaryLabel}
                          </span>
                          <div className={PageStyle.Form__Input_currency}>
                            {/* <FormikControl */}
                            {/*   className     =   {`${PageStyle.Form__Input} ${PageStyle.width100}`} */}
                            {/*   control       =   "input" */}
                            {/*   formik        =     {formik} */}
                            {/*   name          =   "job.job_salary_detail_attributes.min_salary" */}
                            {/*   placeholder   =   {minSalaryHolder} */}
                            {/*   style         =   {InputError(formik, 'job.job_salary_detail_attributes.min_salary')} */}
                            {/*   type          =   "number" */}
                            {/*   pattern       =   "\d*" */}
                            {/*   min           =   "0" */}
                            {/*   disabled      = {!editable} */}
                            {/* /> */}

                            <span className={PageStyle.Form__currency_symbol} style={InputError(formik, 'job.job_salary_detail_attributes.min_salary')} disabled={!editable}>{currencySymbol}</span>
                            <Field component={NumberField} placeholder="e.g. 30,000" type="text" name={"job.job_salary_detail_attributes.min_salary"} className={`${PageStyle.Form__Input} ${PageStyle.width100}`} disabled={!editable} formik={formik} style={InputError(formik, 'job.job_salary_detail_attributes.min_salary')} />
                          </div>
                          <AutocompleteError
                            name="job.job_salary_detail_attributes.min_salary"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "job.job_salary_detail_attributes.min_salary")}
                          />
                        </div>
                        }
                        {salaryInput.includes("max_salary") && <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.job_salary_detail_attributes.max_salary')}>
                            <span className={`red-color`}>*{" "}</span>{maxSalaryLabel}
                          </span>
                          <div className={PageStyle.Form__Input_currency}>
                            <span className={PageStyle.Form__currency_symbol} style={InputError(formik, 'job.job_salary_detail_attributes.max_salary')} disabled={!editable}>{currencySymbol}</span>
                            <Field component={NumberField} type="text" placeholder="e.g. 30,000" name={"job.job_salary_detail_attributes.max_salary"} className={`${PageStyle.Form__Input} ${PageStyle.width100}`} disabled={!editable} formik={formik} style={InputError(formik, 'job.job_salary_detail_attributes.max_salary')} />
                          </div>
                          <AutocompleteError
                            name="job.job_salary_detail_attributes.max_salary"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            style={InputError(formik, "job.job_salary_detail_attributes.max_salary")}
                          />
                        </div>
                        }
                        <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}>
                            <span className={`red-color`}>*{" "}</span>{t('jobs:details:input:salary_duration')}
                          </span>
                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            control="select"
                            default={formik.values.job.job_salary_detail_attributes.salary_duration}
                            formik={formik}
                            name="job.job_salary_detail_attributes.salary_duration"
                            onChange={(option) => formik.setFieldValue("job.job_salary_detail_attributes.salary_duration", option.value)}
                            options={salaryduration}
                            style={InputError(formik, 'job.job_salary_detail_attributes.salary_duration')}
                            value={salaryduration.filter(option => option.value === formik.values.job.job_salary_detail_attributes.salary_duration)}
                            disabled={!editable}
                          />
                        </div>
                      </div>


                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.mt10} ${PageStyle.noDpGrid} mb20`}>
                        <div className={PageStyle.Form__TableCol}>

                          <div className={`${PageStyle.DpFlx} ${PageStyle.Form__CheckLabel} Dpflex16 Mui__CustomCheckbox`}>
                            <Checkbox
                              name="job.job_salary_detail_attributes.salary_hidden"
                              onChange={(event) => handleSalaryHidden(event, formik)}
                              inputProps={{ "aria-label": "Checkbox A" }}
                              checked={formik.values.job.job_salary_detail_attributes.salary_hidden}
                              disabled={!editable}
                              icon={!editable ? (formik.values.job.job_salary_detail_attributes.salary_hidden ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<DefaultCheckbox />)}
                              checkedIcon={!editable ? (formik.values.job.job_salary_detail_attributes.salary_hidden ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<CheckedCheckbox />)}
                            />{" "}
                            <span>
                              {t('jobs:details:input:hide_salary')}
                            </span>
                          </div>

                        </div>
                      </div>

                      {formik.values.job.job_salary_detail_attributes.salary_hidden && <div className={`${PageStyle.Form__TableRow} mt25`} >
                        <div className={`${PageStyle.Form__TableCol} FieldError`}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}> {t('jobs:details:input:displayed_salary')} * </span>
                          <FormikControl
                            className={PageStyle.Form__Input}
                            control="input"
                            name="job.job_salary_detail_attributes.salary_displayed"
                            placeholder=""
                            type="text"
                            formik={formik}
                            style={InputError(formik, 'job.job_salary_detail_attributes.salary_displayed')}
                            disabled={!editable}
                          />
                        </div>
                      </div>
                      }

                      <div className={PageStyle.Form__TableRow}>
                        <div className={PageStyle.Form__TableCol}>
                          <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.seniority_level_id')}>
                            {t('jobs:details:input:seniority')}
                            {/*  <span className={PageStyle.Form__Cont}> {t('page:clients:job-form:texts:optional')} </span> */}
                            <Tooltip className='SimpleTooltip' content={t('tooltip:select_job_role')} background= {'#00325A'} radius={20} padding = {8} placement  = "top" fontSize= "12px">
                              <p className={`tooltipwidthinterview140 d-flex align-items-center`}>&nbsp;<Exclamation/></p>
                            </Tooltip>
                          </label>
                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            components={{ Placeholder }}
                            control="select"
                            default={formik.values.job.seniority_level_id || ''}
                            formik={formik}
                            name="job.seniority_level_id"
                            onChange={(option) => formik.setFieldValue("job.seniority_level_id", option.value)}
                            options={seniority}
                            placeholder={t("tooltip:select_job_role")}
                            style={InputError(formik, 'job.seniority_level_id')}
                            value={seniority.filter(option => option.value === formik.values.job.seniority_level_id)}
                            disabled={!editable}
                          />
                        </div>
                        <div className={PageStyle.Form__TableCol}>
                          <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`} style={InputText(formik, 'job.education')}>
                            {" "}
                            {t('jobs:details:input:education')}{" "}
                            <Tooltip className='SimpleTooltip' content={t("tooltip:min_education")} background= {'#00325A'} radius={20} padding = {8} placement  = "top">
                              <p className={`tooltipwidthinterview200 d-flex align-items-center`}>&nbsp;<Exclamation/></p>
                            </Tooltip>
                            {/*  <span className={PageStyle.Form__Cont}> {t('page:clients:job-form:texts:optional')} </span> */}
                          </label>
                          <FormikControl
                            className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                            components={{ Placeholder }}
                            control="select"
                            default={formik.values.job.education || ''}
                            formik={formik}
                            name="job.education"
                            onChange={(option) => formik.setFieldValue("job.education", option.value)}
                            options={education}
                            placeholder={t("tooltip:min_education")}
                            style={InputError(formik, 'job.education')}
                            value={education.filter(option => option.value === formik.values.job.education)}
                            disabled={!editable}
                          />
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.mt30} ${PageStyle.noDpGrid}`}>
                          <div className="d-flex justify-content-between AlignFlexEnd">
                          <span className={`${PageStyle.Form__Label}`}>
                            </span>
                            <div className={`Generate_with_ai__button mb16`} ref={dropdownRef}>
                           {result.ai_access && <Button buttonstyle={`${ButtonStyle.primarybtn} wauto mlAuto  mb0`} type="button" onClick={toggleDropdown}>{t('button:generate_with_ai')}</Button>}
                            {isOpen && (<div className = {`Generate_with_ai__dropdown removeplaceholder`}>
                                <div className = {`w100 Generate_select ${PageStyle.Form__TableCol} mb25`}>
                                  <label className={`${PageStyle.Form__FloatingLabel}`}>
                                    {t("jobs:details:input:tone_of_voice")}
                                  </label>
                                  <FormikControl
                                  className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                                  components={{ Placeholder }}
                                  control="select"
                                  formik={formik}
                                  default={descriptionModal.data.tone_of_voice || ''}
                                  name="tone_of_voice"
                                  onChange={(option, event) => {
                                    descriptionModal.data.tone_of_voice = option.value;
                                    setDescriptionModal(descriptionModal)
                                   }}
                                  options={toneOfVoiceList(t)}
                                  style={InputError(formik, 'tone_of_voice')}
                                />
                              </div>
                              <div className = {`w100 Generate_select ${PageStyle.Form__TableCol} mb30`}>
                                  <label className={`${PageStyle.Form__FloatingLabel}`}>
                                    {t("jobs:details:input:language")}
                                  </label>
                                  <FormikControl
                                  className={`${PageStyle.Form__CustomSelect} ${PageStyle.widthauto}`}
                                  components={{ Placeholder }}
                                  control="select"
                                  formik={formik}
                                  default={descriptionModal.data.language || ''}
                                  name="language"
                                  onChange={(option, event) => {
                                    descriptionModal.data.language = option.value;
                                    setDescriptionModal(descriptionModal)
                                   }}
                                  options={languageList(t)}
                                  style={InputError(formik, 'language')}
                                />
                              </div>
                              <div className = {`w100 d-flex justify-content-end mt32`}>
                                {/*<button type="button" className= {`${PageStyle.ClearBtn}`} onClick={() => {
                                  toggleDropdown()
                                }}>Cancel</button>*/}
                                <button type="button" className= {`${PageStyle.GoBtn}`} onClick={() => {
                                  canGenerateDescription(formik, descriptionModal, setDescriptionModal, router, setShowLoader, setIsOpen)
                                }}>{t("button:go")}</button>
                              </div>
                            </div>
                            )}
                            </div>
                          </div>
                          <div className={PageStyle.Form__TableCol}>
                          <span className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}>
                              <span className={`red-color`}>*{" "}</span>
                              {t('jobs:details:description')}
                            </span>
                          <FormikControl
                            selector={"#job_description"}
                            apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                            control="customEditor"
                            formik={formik}
                            onInit={(evt, editor) => editorRef.current = editor}
                            textareaName="job.description"
                            style={InputError(formik, 'job.description')}
                            value={formik.values.job.description}
                            onEditorChange={(value) => { formik.setFieldValue("job.description", value) }}
                            disabled={!editable}
                            init={{
                              height: 250,
                              menubar: false,
                              resize: false,
                              readOnly: !editable,
                              plugins: [
                                  'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                  'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                  'insertdatetime', 'media', 'table', 'help', 'wordcount', 'textcolor'
                                ],
                              toolbar: 'undo redo | fontfamily | blocks | ' +
                              'bold italic backcolor forecolor | link | alignleft aligncenter ' +
                              'alignright alignjustify | bullist numlist outdent indent | ' +
                              'removeformat | help',
                              link_target_list: false,
                              content_style: "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap'); body { font-family:Arial; font-size:14px }",
                              forced_root_block: 'div',
                              font_family_formats:"Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Poppins=poppins; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                            }}
                          />
                        </div>
                      </div>

                      <div className={`${PageStyle.Form__TableRow} ${PageStyle.Form__TableRowMB} ${PageStyle.mt30} ${PageStyle.mb0} ${PageStyle.noDpGrid}`}>
                        <div className={PageStyle.Form__TableCol}>

                          <div className={`${PageStyle.DpFlx} ${PageStyle.Form__CheckLabel} Dpflex16 Mui__CustomCheckbox`}>
                            <Checkbox
                              name="job.without_cv"
                              inputProps={{ "aria-label": "Checkbox A" }}
                              checked={formik.values.job.without_cv}
                              onChange={(event) => handleWithoutCV(event, formik)}
                              disabled={!editable}
                              icon={!editable ? (formik.values.job.without_cv ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<DefaultCheckbox />)}
                              checkedIcon={!editable ? (formik.values.job.without_cv ? <SelectedDisabledCheckbox /> : <DisabledCheckbox />) : (<CheckedCheckbox />)}
                            />{" "}
                            <span className={`CheckLabelAlign mt0`}>
                              {t('jobs:details:input:without_cv')}
                            </span>
                          </div>

                        </div>
                      </div>
                    </div>
                    {/* <div className={style.space}></div> */}

                    <div className={`${PageStyle.NewJob__SubmitSection} ${PageStyle.NewJob__Interview_buttons}`}>
                      {editable ? <>
                        <Button buttonstyle={`${ButtonStyle.nobgbutton} `}type="button"
                          onClick={async () => {
                            await setSubmitState('preview')
                            setTimeout(() => { formik.submitForm(); }, 50)
                          }}
                        >
                          {t('button:preview_job')}
                        </Button>
                        {["open", "draft"].includes(job_status.toLocaleLowerCase()) ?
                          <Button buttonstyle={ButtonStyle.secondarybtn}
                            type="button"
                            onClick={async () => {
                              await setSubmitState('draft');
                              setTimeout(() => { formik.submitForm(); }, 50)
                            }}
                          >{t('button:save_as_draft')}
                          </Button>
                          :
                          <Button buttonstyle={ButtonStyle.secondarybtn}
                            type="button"
                            disabled={disabledSaveButton} onClick={async() => {
                              setGotoKanban(true)
                              await setSubmitState('submit')
                              setTimeout(() => {
                                formik.submitForm();
                                showErrorAlert(formik);
                              }, 50)

                            }}
                          >
                            {t('button:save')}
                          </Button>
                          }
                        <Button buttonstyle={ButtonStyle.primarybtn} type="button" disabled={disabledSaveButton} onClick={async () => {
                          setGotoKanban(false)
                          await setSubmitState('submit')
                          setTimeout(() => {
                            formik.submitForm();
                            showErrorAlert(formik);
                          }, 50)
                        }} >
                          {t('button:next_step')}
                        </Button>
                        <a href="#" className="preview-job-link dnone" target="_blank"></a>
                      </>
                        :
                        <>
                          <p style={{ visibility: "hidden" }}></p>
                          {/* <Button buttonstyle={ButtonStyle.primarybtn} type="button"  onClick={() => goToNextPage('interview-stages', props.setPageName, queryClient, REDIRECT.client.jobs.interview_stages.replace('$job_id', initialValues.job?.id))} > */}
                          <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={() => router.push(REDIRECT.client.jobs.job_options.replace('$job_id', initialValues.job?.id))} >
                            {t('button:next_step')}
                          </Button>
                        </>
                      }
                    </div>

                  </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <SelectJobModal setButtonPopup={setButtonPopup}
                buttonPopup={buttonPopup}
                setShowLoader = {setShowLoader} />
      {showLoader && <Loading />}

        {privacyPolicyModal.state && (
          <Modal
            type="confirmation"
            ButtonWidth = {true}
            message={privacyPolicyModal.current_user_type == "client_user" ? t('modal:privacy_policy_modal_message:client_user_message') : t('modal:privacy_policy_modal_message:admin_message') }
            closeModal={() => {
              router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'Active' }})
              setPrivacyPolicyModal({state: false, current_user_type: ''});
            }}
            btnAction={() => {
              if(privacyPolicyModal.current_user_type == "client_user"){
                router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'Active' }})
                setPrivacyPolicyModal({state: false, current_user_type: ''});
              }else{
                let link = REDIRECT.client.settings.data_privacy.privacy_policy
                let params = { policy_setup: true }
                router.push({pathname: link, query: params});
              }
            }}
            texts={{
              button2_text: privacyPolicyModal.current_user_type == "client_user" ? t('modal:privacy_policy_modal_message:client_user_button_text') : t('modal:privacy_policy_modal_message:admin_button_text'),
            }}
          />
        )}

    </>
  );
}

JobForm.layout = ClientDashboard;
export default JobForm;
